import {
	Image,
	Paper,
	Title,
	Stack,
} from '@mantine/core';
import classes from './overview.module.css';
import InukLogo from '@assets/images/avatar.jpg';
import { useTranslation } from 'react-i18next';

const Overview = () => {
	const { t } = useTranslation();
	return (
		<Paper className={classes.container}>
			<Stack align="center" gap={'30px'}>
				<Title className={classes.title}>
					{t('global.welcomeToIglu')}
				</Title>
				<Image
					className={classes.loader}
					src={InukLogo}
				/>
			</Stack>
		</Paper>
	);
};

export default Overview;
